// User Model
import { Model } from '@vuex-orm/core';

export class Wallet extends Model {
    static entity = 'wallets';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            created_at: this.attr(''),
            updated_at: this.attr(''),
            balance: this.attr(0),
            next_deadline: this.attr(''),
            points_to_expire: this.attr(0)
        };
    }
}

export default Wallet;
